window.entrio = window.entrio || {};

function elastic_log(message = 'frontend_log', data = {}) {
    setTimeout(function () {
        $.ajax({
            url: siteUrl + 'ajax/elastic_log',
            data: {
                "message" : message,
                "data": data
            },
            dataType: 'json',
            type: 'post',
            success: function (data) {
                console.log('error logged');
            }
        })
    }, 200);
};

window.entrio.entrioApp.controller('authenticationController', ['$scope', '$rootScope', function($scope, $rootScope){
    if(typeof(userData) !== 'undefined'){
        $rootScope.currentUser.isLoggedIn = true;
        $rootScope.currentUser.info = userData;
    }

    if(typeof(userEvents) !== 'undefined') {
        $rootScope.currentUser.hasEvents = true;
    }

    if (typeof(userStats) !== 'undefined') {
        $rootScope.userStats = userStats;
        $rootScope.selectedEvent = {};
        if ($rootScope.userStats.length > 0) {
            $rootScope.selectedEvent = $rootScope.userStats[0];

            if (typeof globalEventId !== 'undefined') {

                $($rootScope.userStats).each(function (index, value) {
                    if (value.total_stats.event_id == globalEventId)
                        $rootScope.selectedEvent = $rootScope.userStats[index];

                });
            }
        }
    }

    $scope.formLoading = false;
    $scope.loginPage = loginPage == 'undefined' ? 'homepage' : loginPage;
    $scope.loginModel = {
        email: "",
        page: $scope.loginPage,
        password: "",
        auth_token: ''
    };

    $scope.registerModel = {
        email: "",
        repeat_email: "",
        firstName: "",
        lastName: "",
        page: "homepage",
        password: "",
        newsletter_subscribe: false,
        tos: false
    };


    $scope.forgotPassword = {
        email: ''
    };

    $scope.passwordRequestSent = false;

    $scope.forgotPassword = function (event) {
        $scope.forgotPasswordForm.$setSubmitted(true);

        if ($scope.forgotPasswordForm.$invalid) {
            return false;
        }

        $scope.formLoading = true;
        $scope.forgotPasswordForm.$valid = false;

        $.ajax(
            {
                url: siteUrl + 'auth/reset_pwd_request_ajax',
                type: "POST",
                data: {
                    email: $scope.forgotPassword.email
                },
            }).done(function (data) {
                data = JSON.parse(data);

                if (data.success === true) {
                    makeInfoBar(data.message, 'success', 500, 8000);
                    $scope.forgotPasswordForm.$valid = true;
                    $scope.passwordRequestSent = true;
                } else {
                    makeInfoBar(data.validation_errors, 'error', 500, 8000);
                    $scope.forgotPasswordForm.$submitted = false;
                    $scope.forgotPasswordForm.$valid = false;
                    $scope.passwordRequestSent = false;
                }

                $scope.formLoading = false;
                $scope.$apply();
        });
    }

    $scope.sendPasswordReset = function (form, e) {
        form.$setSubmitted(true);

        if (form.$invalid) {
            e.preventDefault();
            return false;
        }
    }

    $scope.captchaSuccess = true;
    $scope.captchaToken = null;
    $scope.register = function (event) {
        $scope.captchaToken = $scope.validate_Captcha();

        $scope.registerForm.$setSubmitted(true);
        $scope.continueRegister();
    };

    $scope.continueRegister = function() {
        if ($scope.registerForm.$invalid || !$scope.captchaSuccess) {
            return false;
        }

        var sendData = {
            email: $scope.registerModel.email,
            repeat_email: $scope.registerModel.repeat_email,
            password: $scope.registerModel.password,
            newsletter_subscribe: $scope.registerModel.newsletter_subscribe,
            "first_name": $scope.registerModel.firstName,
            "last_name": $scope.registerModel.lastName,
            captcha_token: $scope.captchaToken
        };

        $scope.formLoading = true;

        $.ajax(
            {
                url: siteUrl + 'auth/' + "register",
                type: "POST",
                data: sendData,

            }).done(function (data) {
            $scope.formLoading = false;
            data = JSON.parse(data);

            makeInfoBar(data.message, detect_notification_severity(data), 500, 8000);
            if (data.status === true) {
                if ($('#CCFirstName').length || $('#BuyerFirstName').length || $('.customFieldTypeEmail').length) prefillPaymentFormAfterLogin(data);
                $rootScope.currentUser.isLoggedIn = true;
                $rootScope.currentUser.info = data.userData;
                $rootScope.currentUser.hasEvents = Boolean(data.my_events);
                $rootScope.userStats = data.my_events_stats;
                $rootScope.selectedEvent = {};
                if ($rootScope.userStats.length > 0) {
                    $rootScope.selectedEvent = $rootScope.userStats[0];
                }
            }
            if (data.redirect) {
                setTimeout(function () {
                    window.location.href = data.redirect;
                }, 1500);
            }

            $scope.$apply();
        });
    };

    $scope.validate_Captcha = function(){
        if (enableCaptcha == 0) {
            return true;
        }

        var c = $('.g-recaptcha').length;
        if (c == 0) {
            return true;
        }

        for (var i = 0; i < c; i++){
            var captchaResponse = grecaptcha.enterprise.getResponse(i);
            if (captchaResponse != ""){
                $scope.captchaSuccess = true;
                $scope.$applyAsync();

                return captchaResponse;
            }
        }
        $scope.captchaSuccess = false;
        $scope.$applyAsync();

        return false;
    };

    $scope.resetModel = {
        password: "",
        password_confirm: ""
    };

    $scope.checkUser = function () { // Ovo je u principu keep alive metoda koja usput dovlači i korisnički profil u javascript
        $.ajax({
            url: siteUrl + 'auth/' + "getUserData",
        }).done(function (data) {
            data = JSON.parse(data);
            if (data.status === true) {
                $rootScope.currentUser.isLoggedIn = true;
                $rootScope.currentUser.info = data.userData;
                $rootScope.currentUser.hasEvents = Boolean(data.my_events);

                $rootScope.userStats = data.my_events_stats;
                $rootScope.selectedEvent = {};
                if ($rootScope.userStats.length > 0) {
                    $rootScope.selectedEvent = $rootScope.userStats[0];

                    if (typeof globalEventId !== 'undefined') {

                        $($rootScope.userStats).each(function (index, value) {
                            if (value.total_stats.event_id == globalEventId)
                                $rootScope.selectedEvent = $rootScope.userStats[index];


                        });
                    }

                }
            } else {
                $rootScope.currentUser.isLoggedIn = false;
            }

            $scope.$apply();
        });
    }

    $rootScope.fbModalOpen = false;
    $rootScope.closeFbModal = function () {
        $rootScope.fbModalOpen = false;
    }
    $scope.socialLoginLoading = false;

    $scope.fbLogin = function (type) {
        //window.location.replace(siteUrl + "auth/reset_pwd_request?p=" + "fb_redirect");
        //return false;
        $scope.socialLoginLoading = true;
        require_perms(function (is_authenticated) {
            if (is_authenticated) {

                startServerProcess(type);
            } else {
                elastic_log('facebook require_perms failed', {is_authenticated : is_authenticated, type : type, function:'FB.login:237'});
                $scope.socialLoginLoading = false;
                $scope.$apply();
                // infoMessage('Sorry, we cannot grant you access untill you grant us email //permission', 'info');
            }
        });

    };


    $scope.googleLogin = function (type) {
        $scope.socialLoginLoading = true;
        $.ajax({
            url: siteUrl + 'auth/get_google_login_url',
            data: {
                "page": globalPageName
            },
            dataType: 'json',
            type: 'post',
            success: function (data) {
                if (data.redirect) {
                    setTimeout(function () {
                        const popup = window.open(data.redirect.url);
                    }, 100);

                }
            },
            fail: function(response){
                elastic_log('facebook startServerProcess failed', {response : response, function:'FB.login:297'});
            }

        });
    };

    window.addEventListener('message', function(event) {
        if ((event.origin === baseUrl) || (event.origin + '/' === baseUrl)) {
            const accessToken = event.data.accessToken;
            const email = event.data.email;
            if (typeof accessToken === 'undefined' || typeof email === 'undefined') {
                return;
            }
            $.ajax({
                url: siteUrl + 'auth/google_login?google_token='+accessToken+'&email='+email,
                dataType: 'json',
                type: 'get',
                success: function (data) {
                    if (data.redirect) {
                        setTimeout(function () {
                            window.location.href = data.redirect;
                        }, 1500);
                    }

                    makeInfoBar(data.message, detect_notification_severity(data), 500, 8000);
                    if (data.status === true) {
                        if ($("#StandAloneLogin").length > 0) {
                            document.location.href = "/";
                        }
                        if($('#CCFirstName').length || $('#BuyerFirstName').length || $('.customFieldTypeEmail').length) prefillPaymentFormAfterLogin(data);

                        $rootScope.currentUser.isLoggedIn = true;
                        $rootScope.currentUser.info = data.userData;
                        $rootScope.currentUser.hasEvents = Boolean(data.my_events);
                        if ($rootScope.updateCC != undefined) {
                            $rootScope.updateCC();
                        }
                        $rootScope.userStats = data.my_events_stats;
                        $rootScope.selectedEvent = {};
                        if ($rootScope.userStats.length > 0) {
                            $rootScope.selectedEvent = $rootScope.userStats[0];
                        }

                    }
                    $scope.socialLoginLoading = false;
                    $scope.$apply();
                },
                fail: function(response){
                }

            });
        }
    });

    function startServerProcess(type) {
        setTimeout(function () {
            $.ajax({
                url: siteUrl + 'auth/fb_login',
                data: {
                    "page": globalPageName
                },
                dataType: 'json',
                type: 'post',
                success: function (data) {
                    if (data.error !== "") {

                    }
                    if (data.redirect) {
                        setTimeout(function () {
                            window.location.href = data.redirect;
                        }, 1500);

                    }

                    makeInfoBar(data.message, detect_notification_severity(data), 500, 8000);
                    if (data.status === true) {
                        if ($("#StandAloneLogin").length > 0) {
                            document.location.href = "/";
                        }
                        if($('#CCFirstName').length || $('#BuyerFirstName').length || $('.customFieldTypeEmail').length) prefillPaymentFormAfterLogin(data);

                        $rootScope.currentUser.isLoggedIn = true;
                        $rootScope.currentUser.info = data.userData;
                        $rootScope.currentUser.hasEvents = Boolean(data.my_events);
                        if ($rootScope.updateCC != undefined) {
                            $rootScope.updateCC();
                        }
                        $rootScope.userStats = data.my_events_stats;
                        $rootScope.selectedEvent = {};
                        if ($rootScope.userStats.length > 0) {
                            $rootScope.selectedEvent = $rootScope.userStats[0];
                        }

                        if ($rootScope.currentUser.info.newFacebookUser) {
                            $rootScope.fbModalOpen = true;
                            $("#facebook_register_modal").on("click", function(evt) { evt.stopPropagation(); });
                        }
                    } else {
                        elastic_log('facebook data.status false', {response : data, function:'FB.login:290'});
                    }
                    $scope.socialLoginLoading = false;
                    $scope.$apply();
                },
                fail: function(response){
                    elastic_log('facebook startServerProcess failed', {response : response, function:'FB.login:297'});
                }

            });
        }, 200);
    }

    function require_perms(callback) {
        FB.getLoginStatus(function (response) {
            if (response.authResponse) {
                FB.api('/me/permissions', function (perms_response) {
                    var email_granted = false;

                    if(perms_response !== undefined && perms_response.data !== undefined) {
                        jQuery.each(perms_response.data, function (key, value) {
                            if (value.permission === 'email') {
                                email_granted = (value.status === 'granted');
                            }
                        });
                    }

                    if (email_granted) {
                        console.log('email permission granted.');
                        callback(true);
                    } else {
                        // FB.api('/me/permissions', 'delete', function (response) {
                        //     console.log('revoking  permission...');
                        // });
                        console.log('requesting permissions by FB login...');
                        FB.login(function (response) {
                            console.log('FB login responded');
                            if (response.status == 'connected') {
                                console.log('permission granted');
                                callback(true);
                            } else {
                                elastic_log('facebook permission request failed', {response : response, perms_response : perms_response, function:'FB.login:327'});
                                console.log('permission request failed');
                                callback(false);
                            }
                        }, {
                            scope: fbScope
                        });
                    }
                });
                // user is not connected to the app, so show an auth dialog
            } else {
                console.log('requesting permission...');
                FB.login(function (response) {
                    if (response.authResponse) {
                        console.log('permission granted');
                        callback(true);
                    } else {
                        elastic_log('facebook permission request failed', {response : response, function:'FB.login:345'});
                        console.log('permission request failed');
                        callback(false);
                    }
                }, {
                    scope: fbScope
                });
            }
        });
    }

    $scope.login = function (event, type) {
        $scope.loginForm.$setSubmitted(true);

        if ($scope.loginForm.$invalid) {
            return false;
        }

        $scope.formLoading = true;
        $.ajax(
            {
                url: siteUrl + 'auth/' + "login",
                type: "POST",
                data: $scope.loginModel,

            }).done(function (data) {
            $scope.formLoading = false;

            data = JSON.parse(data);
            if (data.error === "email_not_found") {
                $rootScope.$apply();

                makeInfoBar(data.message, 'warning', 500, 8000);
                $scope.registerModel.email = $scope.loginModel.email;
                $scope.$apply();

                if (type === 'HEADER') {
                    $(".js-header-auth-register").click();
                } else if (type === 'PAYMENT') {
                    $(".js-inline-auth-register").click();
                }

                return;
            }

            if (data.error === 'authy_user_register_error') {
                makeInfoBar(data.message, 'warning', 500, 8000);
                $scope.$applyAsync();
                return;
            }

            if (data.error === 'token_verified') {
                $rootScope.$apply();

                const $authHeaderLoginForm = document.querySelector('.js-header-auth-login-form');
                const $authHeader2faForm = document.querySelector('.js-header-auth-2fa-form');

                if($authHeaderLoginForm && $authHeader2faForm) {
                    $authHeaderLoginForm.classList.remove('form-fade');

                    setTimeout(function() {
                        $authHeaderLoginForm.classList.add('form-hidden');
                        $authHeader2faForm.classList.remove('form-hidden');
                    }, 150);

                    setTimeout(function() {
                        $authHeader2faForm.classList.add('form-fade');
                    }, 300);
                }

                const $authLoginForm = document.querySelector('.js-inline-auth-login-form');
                const $auth2faForm = document.querySelector('.js-inline-auth-2fa-form');

                if($authLoginForm && $auth2faForm) {
                    $authLoginForm.classList.remove('form-fade');

                    setTimeout(function() {
                        $authLoginForm.classList.add('form-hidden');
                        $auth2faForm.classList.remove('form-hidden');
                    }, 150);

                    setTimeout(function() {
                        $auth2faForm.classList.add('form-fade');
                    }, 300);
                }

                setTimeout(function() {
                    $("#2fa-token").focus();
                    makeInfoBar(data.message, 'success', 500, 8000);
                    $scope.$applyAsync();
                }, 600);

                return;
            }

            if (data.status === true) {
                if (document.querySelector('.site-header__sub-list--is-auth.is-shown')) {
                    document.querySelector('.site-header__sub-list--is-auth.is-shown').classList.remove('is-shown');
                }
                $scope.applyData(data);
            } else {
                makeInfoBar(data.message, 'warning', 500, 8000);
            }

            $scope.$apply();
        });

    };

    $scope.verifyToken = function () {
        $scope.inputForm = $scope.twoFaForm == undefined ? $scope.loginForm : $scope.twoFaForm;

        $scope.inputForm.$setSubmitted(true);
        if ($scope.inputForm.$invalid) {
            return false;
        }
        $scope.formLoading = true;
        if($scope.twoFaToken == undefined){
            $scope.token = $scope.loginModel.auth_token;
        }else{
            $scope.token = $scope.twoFaToken;
        }
        $.ajax({
            url: siteUrl + 'auth/verify_token',
            type: 'POST',
            data: {
                "auth_token": $scope.token,
                "email": $scope.loginModel.email,
                "password": $scope.loginModel.password,
            },
        }).done(function (data) {
            $scope.formLoading = false;
            data = JSON.parse(data);
            if (data.error === 'wrong_login_info') {
                $rootScope.$apply();

                $('.js-header-auth-login').click();

                setTimeout(function(){
                    $("#loginEmailInput").focus();
                    makeInfoBar(data.message, detect_notification_severity(data), 500, 8000);
                }, 600);
                return;
            }
            if (data.status === true) {
                $scope.applyData(data);
            } else {
                makeInfoBar(data.message, detect_notification_severity(data), 500, 8000);
            }
            $scope.$apply();
        });
    }

    $scope.sendAuthySms = function(){
        $.ajax({
            url: siteUrl + 'auth/register_2fa_user',
            type: 'POST',
            data: {
                "user_email": $scope.loginModel.email,
                "force_sms": true,
            },
        }).done(function (data) {
            data = JSON.parse(data);
            makeInfoBar(data.message, 'success', 500, 8000);
        });
    }

    $scope.applyData = function (data) {
        if ($("#StandAloneLogin").length > 0 && !data.redirect) {
            data.redirect = "/";
        }

        if($('#CCFirstName').length || $('#BuyerFirstName').length || $('.customFieldTypeEmail').length) prefillPaymentFormAfterLogin(data);
        $rootScope.currentUser.isLoggedIn = true;
        $rootScope.currentUser.info = data.userData;
        $rootScope.currentUser.hasEvents = Boolean(data.my_events);
        $rootScope.userStats = data.my_events_stats;
        $rootScope.selectedEvent = {};
        if($rootScope.userStats.length > 0){
            $rootScope.selectedEvent = $rootScope.userStats[0];
            if( typeof globalEventId !== 'undefined'){
                $($rootScope.userStats).each(function(index, value) {
                    if(value.total_stats.event_id == globalEventId)
                        $rootScope.selectedEvent = $rootScope.userStats[index];
                });
            }
        }
        $rootScope.$apply();

        const $eventsList = document.querySelector('.js-events-list');
        const $listItems = $(data.my_events);

        if ($eventsList && $listItems.length > 0) {
            for (let index = $listItems.length - 1; index >= 0; index--) {
                $eventsList.insertBefore($listItems[index], $eventsList.firstChild);
            }
        }

        makeInfoBar(data.message, 'success', 500, 8000);
        if (data.redirect) {
            setTimeout(function () {
                window.location.href = data.redirect;
            }, 1500);
        }
    }
}]);

window.entrio.entrioApp.directive('confirmEmail', ['$interpolate', '$parse', function($interpolate, $parse) {
    return {
        require: 'ngModel',
        link: function(scope, elem, attr, ngModelCtrl) {

            var emailToMatch = $parse(attr.confirmEmail);
            var emailFn = $interpolate(attr.confirmEmail)(scope);

            scope.$watch(emailFn, function(newVal) {
                ngModelCtrl.$setValidity('confirmEmail', ngModelCtrl.$viewValue == newVal);
            });

            ngModelCtrl.$validators.confirmEmail = function(modelValue, viewValue) {
                var value = modelValue || viewValue;
                return value == emailToMatch(scope);
            };
        }
    };
}]);

window.entrio.entrioApp.directive('confirmPassword', ['$interpolate', '$parse', function($interpolate, $parse) {
    return {
        require: 'ngModel',
        link: function(scope, elem, attr, ngModelCtrl) {
            var passwordToMatch = $parse(attr.confirmPassword);
            var passwordFn = $interpolate(attr.confirmPassword)(scope);

            scope.$watch(passwordFn, function(newVal) {
                ngModelCtrl.$setValidity('confirmPassword', ngModelCtrl.$viewValue == newVal);
            })

            ngModelCtrl.$validators.confirmPassword = function(modelValue, viewValue) {
                var value = modelValue || viewValue;
                return value == passwordToMatch(scope);
            };
        }
    }
}]);

window.entrio.entrioApp.controller('sharedController', ['$scope' , '$rootScope' , function ($scope, $rootScope) {
    $rootScope.currentUser = {
        info: {},
        isLoggedIn: null,
    };

    $scope.setCookie = function(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    $scope.getCookieByName = function(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}]);

function prefillPaymentFormAfterLogin(data){
    // Prefill known data
  if(!$('#BuyerFirstName').val()) {
    $('#BuyerFirstName').val(data.userData['firstName']);
    angular.element(document.getElementById("BuyerFirstName")).triggerHandler('input');
  }

  if(!$('#BuyerLastName').val()) {
    $('#BuyerLastName').val(data.userData['firstName']);
    angular.element(document.getElementById("BuyerLastName")).triggerHandler('input');
  }

    if(!$('#CCFirstName').val()) {
      $('#CCFirstName').val(data.userData['firstName']);
      angular.element(document.getElementById("CCFirstName")).triggerHandler('input');
    }

    if(!$('#CCLastName').val()) {
      $('#CCLastName').val(data.userData['lastName']);
      angular.element(document.getElementById("CCLastName")).triggerHandler('input');
    }
    if(!$('#CCCity').val()) {
      $('#CCCity').val(data.userData['city']);
      angular.element(document.getElementById("CCCity")).triggerHandler('input');
    }
    if(!$('#CCPost').val()){
      $('#CCPost').val(data.userData['postalCode']);
      angular.element(document.getElementById("CCPost")).triggerHandler('input');
    }
    if(!$('#CCAddress').val()) {
      $('#CCAddress').val(data.userData['address']);
      $('#CCAddress').blur();
      angular.element(document.getElementById("CCAddress")).triggerHandler('input');
    }
    if(!$('.customFieldTypeFirstName').val()) {
      $('.customFieldTypeFirstName').first().val(data.userData['firstName']);

      angular.element( $('.customFieldTypeFirstName').first()[0]).triggerHandler('input');
    }
    if(!$('.customFieldTypeLastName').val()) {
      $('.customFieldTypeLastName').first().val(data.userData['lastName']);
      angular.element( $('.customFieldTypeLastName').first()[0]).triggerHandler('input');

    }
    if(!$('.customFieldTypeEmail').val()) {
      $('.customFieldTypeEmail').first().val(data.userData['email']);
      angular.element( $('.customFieldTypeEmail').first()[0]).triggerHandler('input');
    }

    if(!$('.customFieldTypePeriodicEmail').val()) {
      $('.customFieldTypePeriodicEmail').first().val(data.userData['email']);
      angular.element( $('.customFieldTypePeriodicEmail').first()[0]).triggerHandler('input');
    }

  if(!$('#BuyerCity').val()) {
    $('#BuyerCity').val(data.userData['city']);
    $('#BuyerCity').blur();
    $('#BuyerCityPost').val(data.userData['city']);
    angular.element(document.getElementById("BuyerCity")).triggerHandler('input');
    angular.element(document.getElementById("BuyerCityPost")).triggerHandler('input');
  }

  setTimeout(function(){
    $('#BuyerCity').blur();
    $('#CCAddress').blur();
    if(data.userData["country"]){
      $("#BuyerCountry").val(data.userData["country"]).change();
    }
  }, 300);
}


$(function(){
    angular.bootstrap(document, ['entrioApp']);
});
